export const MAP_ITEM_OPTIONS = {
  pin: [
    { mapLabel: 'Sample Point', hexColor: 'red' },
    { mapLabel: 'Travel Via', hexColor: 'blue' },
    { mapLabel: 'Entrance', hexColor: 'blue' },
    { mapLabel: 'Timber', hexColor: 'green' },
    { mapLabel: 'Turntable', hexColor: 'orange' },
    { mapLabel: 'ESB Pylons', hexColor: 'yellow' },
    { mapLabel: 'Fueling Area', hexColor: 'grey' },
    { mapLabel: 'Service Area', hexColor: 'blue' },
    { mapLabel: 'Lowloader', hexColor: 'purple' },
  ],
  line: [
    { mapLabel: 'Stacking Area Line', hexColor: 'orange' },
    { mapLabel: 'Forest Road', hexColor: '#653700' },
    { mapLabel: 'Public Road', hexColor: 'black' },
    { mapLabel: 'Power Lines', hexColor: 'yellow' },
    { mapLabel: 'Safe Cross Point', hexColor: 'white' },
    { mapLabel: 'Main Extraction Line', hexColor: 'red' },
    { mapLabel: 'Extraction Direction', hexColor: 'pink' },
    { mapLabel: 'Drain', hexColor: '#ADD8E6' },
    { mapLabel: 'Stream', hexColor: '#4682B4' },
    { mapLabel: 'River', hexColor: '#00008B' },
  ],
  polygon: [
    { mapLabel: 'Boundary', hexColor: 'white' },
    { mapLabel: 'Stacking Area', hexColor: 'blue' },
    { mapLabel: 'Sub Compartments', hexColor: 'purple' },
    { mapLabel: 'Wet Area', hexColor: 'grey' },
    { mapLabel: 'Bog', hexColor: 'grey' },
    { mapLabel: 'Protected Area', hexColor: 'grey' },
    { mapLabel: 'Clearfell Area', hexColor: 'blue' },
    { mapLabel: 'Windblow', hexColor: 'orange' },
  ],
};
